export function flattenWrapper(
  rows: Array<{
    kpi_type: string
    time: string
    dim_name: string
    dim_value: string
    value: number
  }>,
): { columns: string[]; rows: Array<Record<string, unknown>> } {
  return {
    columns: ['Time', 'Dimension', 'Value', 'Amount'],
    rows: rows.map((r) => ({
      Time: r.time,
      Dimension: r.dim_name,
      Value: r.dim_value,
      Amount: r.value,
    })),
  }
}
